module.exports = __webpack_public_path__ + "static/media/uk.a4e46a19.jpg";